import { TabPill } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';

export type TaskFilterButtonProps = {
  isActive: boolean;
  leftIconName?: IconName;
  onCancel?: () => void;
  onClick?: () => void;
  rightIconName?: IconName;
  title: string;
};

export const TaskFilterButton = ({ isActive, onClick, title }: TaskFilterButtonProps) => (
  <TabPill isActive={isActive} label={title} onClick={onClick} />
);
